import { HTMLProps, MouseEventHandler, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import { Color } from '@diritto/common/style/color';
import { FilterIcon } from '@/icons/FilterIcon';
import { useMenuRef } from '@/ui-hooks/useMenuRef';
import { FilterItemList, FilterMenuGroup } from '@/ui-components/common/FilterItemList';

type Modify<T, R> = Omit<T, keyof R> & R;

type FilterBoxProps = Modify<
  HTMLProps<HTMLInputElement>,
  {
    className?: string;
    filterMenuGroups: FilterMenuGroup[];
    isFiltering?: boolean;
  }
>;

export const FilterBox = ({ className, filterMenuGroups, isFiltering = false }: FilterBoxProps) => {
  const { ref, isOpen, setOpen } = useMenuRef<HTMLDivElement>();

  const handleClick: MouseEventHandler<HTMLDivElement> = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(prev => !prev);
    },
    [setOpen],
  );

  const handleChange = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen, setOpen]);

  return (
    <div ref={ref} className={twMerge('relative flex items-center justify-center h-6', className)}>
      <div onClick={handleClick} className="flex items-center justify-center cursor-pointer ">
        <FilterIcon color={isFiltering ? Color.Primary500 : Color.Gray600} />
      </div>
      {isOpen && <FilterItemList onClick={handleChange} filterMenuGroups={filterMenuGroups} />}
    </div>
  );
};
